enum AuthenticationMethods {
  TOKEN_CREATE = 'token.create',
  TOKEN_REFRESH = 'token.refresh',
}

export default AuthenticationMethods;
